import * as React from 'react';
import Entity from '../../../../../../foundation/domain/Entity';
import EntityId from '../../../../../../foundation/domain/EntityId';
import Exercise from '../exercise/Exercise';
import BBMLParser from '../../../../../pages/components/exercises/BBMLParser';
import StringMap from '../../../../../../../../../backend/code/foundation/dataStructures/maps/StringMap';

export default class ExerciseTemplate extends Entity<ExerciseTemplate> {

	public constructor (id: EntityId<ExerciseTemplate>, private name: string, private content: string) {
		super(id);
	}

	public getName () {
		return this.name;
	}

	public getContent () {
		return this.content;
	}

	public getDescription () {
		switch (this.getId().getValue()) {
			case 1:
				return 'Determine whether a proposition is true of false.';
			case 2:
				return 'Multiple choice - choices ordered alphabetically';
			case 3:
				return 'Multiple choice - custom ordering';
			case 4:
				return 'A question that is answered by writing text.';
			case 5:
				return 'A question that is answered with a math formula.';
			case 6:
				return 'An image with a question, answered by writing text.';
			case 7:
				return 'Multiple choice with randomly selected question/answer pair.';
			case 8:
				return 'A multiple choice question that is answered by clicking a button.';
			case 9:
				return 'A question that is answered by writing a chemical formula';
			case 10:
				return 'A question that is answered by typing text.';
			case 11:
				return 'A multiple choice question that is answered by clicking a button.';
			case 12:
				return 'A question that is answered by typing case-sensitive text.';
			case 13:
				return 'A question that is answered in Turkish.';
			default:
				return 'invalid exercise template id';
		}
	}

	public getQuestion (exercise: Exercise) {
		switch (this.getId().getValue()) {
			case 1:
				return BBMLParser.execute(exercise.getContents()[1]);
			case 2:
				return (
					<span>
						{BBMLParser.execute(exercise.getContents()[0])} {<span style={{color: 'lightblue', fontWeight: 'bold'}}>?</span>} {BBMLParser.execute(exercise.getContents()[2])}
					</span>
				);
			case 3:
				return (
					<span>
						{BBMLParser.execute(exercise.getContents()[0])} {<span style={{color: 'lightblue', fontWeight: 'bold'}}>?</span>} {BBMLParser.execute(exercise.getContents()[3])}
					</span>
				);
			case 4:
				return BBMLParser.execute(exercise.getContents()[0]);
			case 5:
				return 'question';
			case 6:
				const contents = exercise.getContents();

				const licenseLinkMap: StringMap<string> = {
					'CC BY-SA 3.0': 'http://creativecommons.org/licenses/by-sa/3.0',
					'GFDL': 'http://www.gnu.org/copyleft/fdl.html'
				};

				return (
					<div>
						<div><a title={contents[0] + ' - ' + ' by ' + contents[1] + (contents[2] !== '' ? ' - via ' + contents[2] : '') + (contents[3] !== '' ? ' - ' + contents[3] + ' (' + licenseLinkMap[contents[3]] + ')' : '')} href={contents[4]} ><img src={contents[5]} style={{width: '320px'}} /></a></div>
						<div>{BBMLParser.execute(contents[6])}</div>
					</div>
				);
			case 7:
				return BBMLParser.execute(exercise.getContents()[1].replace('*value*', exercise.getContents()[0].split('\n')[Number(0)]));
			case 8:
				return BBMLParser.execute(exercise.getContents()[0]);
			case 9:
				return BBMLParser.execute(exercise.getContents()[0]);
			case 10:
				return BBMLParser.execute(exercise.getContents()[0]);
			case 11:
				return BBMLParser.execute(exercise.getContents()[0]);
			case 12:
				return BBMLParser.execute(exercise.getContents()[0]);
			case 13:
				return exercise.getContents()[0];
			default:
				return 'invalid exercise template id';
		}
	}

	public getAnswer (exercise: Exercise) {
		switch (this.getId().getValue()) {
			case 1:
				return exercise.getContents()[0];
			case 2:
				return BBMLParser.execute(exercise.getContents()[1].split('\n')[0]);
			case 3:
				return BBMLParser.execute(exercise.getContents()[2].split('\n')[Number(exercise.getContents()[1])]);
			case 4:
				return BBMLParser.execute(exercise.getContents()[1]);
			case 5:
				return 'answer';
			case 6:
				return BBMLParser.execute(exercise.getContents()[7]);
			case 7:
				return BBMLParser.execute(exercise.getContents()[2].split('\n')[Number(0)]);
			case 8:
				return BBMLParser.execute(exercise.getContents()[2].split('\n')[Number(exercise.getContents()[1])]);
			case 9:
				return BBMLParser.execute(exercise.getContents()[1]);
			case 10:
				return exercise.getContents()[1];
			case 11:
				return exercise.getContents()[2].split('\n')[Number(exercise.getContents()[1])];
			case 12:
				return exercise.getContents()[1];
			case 13:
				return exercise.getContents()[1];
			default:
				return 'invalid exercise template id';
		}
	}

	public getExplanation (exercise: Exercise) {
		const index = this.getExplanationIndex();

		return index === null ? '' : BBMLParser.execute(exercise.getContents()[index]);
	}

	public getExplanationIndex () {
		switch (this.getId().getValue()) {
			case 1:
				return 2;
			case 2:
				return 3;
			case 3:
				return 4;
			case 4:
				return 2;
			case 5:
				return 2;
			case 6:
				return 8;
			case 7:
				return 4;
			case 8:
				return 3;
			case 9:
				return 2;
			case 10:
			case 11:
			case 12:
			case 13:
			default:
				return null;
		}
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/lessons/domain/aggregates/exerciseTemplate/ExerciseTemplate.tsx